function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
export function updateAggregatedDataCache(_ref) {
  var newData = _ref.newData,
    queryKey = _ref.queryKey,
    queryClient = _ref.queryClient;
  queryClient.setQueryData(queryKey, function (existingData) {
    if (!isExpectedResponse(newData)) {
      return existingData;
    }
    if (!existingData) {
      return newData;
    }
    if (!isExpectedResponse(existingData)) {
      return existingData;
    }

    /*
           If the data in the cache is newer than the received data, keep the existing data.
          The sequence diagram for the use-case where this occurs is visualized below.  Additionally,
          there's a test case for this situation called "uses the most recently generated data" in index.test.tsx
           (To make the diagram easier to read, the server is split into "Server1" and "Server2" which could represent
          multiple pods.  However, this situation can also happen if there was only 1 pod)
                                       +---------+                           +---------+                    +---------+
                                      | Client  |                           | Server1 |                    | Server2 |
                                      +---------+                           +---------+                    +---------+
                                           |                                     |                              |
                                           | Submit application request          |                              |
                                           |------------------------------------>|                              |
                                           |                                     | ------------------------\    |
                                           |                                     |-| Application submitted |    |
                                           |                                     | |-----------------------|    |
                                           |                                     |                              |
                                           | Complete application request        |                              |
                                           |------------------------------------------------------------------->|
                                           |                                     |                              | ------------------------\
                                           |                                     |                              |-| Application completed |
                                           |                                     |                              | |-----------------------|
                                           |                                     |                              |
                                           |                                    Application completed response  |
                                           |<-------------------------------------------------------------------|
                                           |                                     |                              |
                                           |      Application submitted response |                              |
                                           |<------------------------------------|                              |
      -----------------------------------\ |                                     |                              |
      | In this case, we want UI to show |-|                                     |                              |
      | "completed" - not "submitted"    | |                                     |                              |
      |----------------------------------| |                                     |                              |
          */
    if (existingData.response.meta.dateGenerated > newData.response.meta.dateGenerated) {
      return existingData;
    }
    var initialProps = existingData.response.included.find(function (item) {
      return item.type === 'application_page_initial_props';
    });
    if (!initialProps) {
      return newData;
    }
    return _objectSpread(_objectSpread({}, newData), {}, {
      response: _objectSpread(_objectSpread({}, newData.response), {}, {
        included: [
        // We don't want to re-load the initialProps because we're not sure
        // if the legacy code can handle the initialProps changing.  There
        // could be subtle bugs if this happens
        initialProps].concat(_toConsumableArray(newData.response.included))
      })
    });
  });
}
function isExpectedResponse(res) {
  return res !== null && _typeof(res) === 'object' && 'response' in res && _typeof(res.response) === 'object' && !!res.response && 'included' in res.response && Array.isArray(res.response.included) && 'meta' in res.response && _typeof(res.response.meta) === 'object' && !!res.response.meta && 'dateGenerated' in res.response.meta && typeof res.response.meta.dateGenerated === 'string';
}
export function findByType(data, type) {
  return data.find(function (item) {
    return item.type === type;
  });
}
export function filterByType(data, type) {
  return data.filter(function (item) {
    return item.type === type;
  });
}
export function filterByTypes(data, types) {
  return data.filter(function (item) {
    return types.some(function (type) {
      return item.type === type;
    });
  });
}
export function useQueryParams() {
  var history = useHistory();
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var queryParams = useMemo(function () {
    return new URLSearchParams(search);
  }, [search]);
  var updateQueryParams = function updateQueryParams(values) {
    var newQueryParams = new URLSearchParams(_objectSpread({}, Object.fromEntries(queryParams)));
    for (var key in values) {
      if (values[key]) {
        newQueryParams.set(key, values[key]);
      } else if (values[key] === '') {
        newQueryParams["delete"](key);
      }
    }
    history.replace({
      search: newQueryParams.toString()
    });
  };
  return {
    queryParams: queryParams,
    updateQueryParams: updateQueryParams
  };
}
export function getColumnSort(queryParams) {
  var sortParam = queryParams.get('sort');
  if (sortParam) {
    var _sortParam$split = sortParam.split('.'),
      _sortParam$split2 = _slicedToArray(_sortParam$split, 2),
      id = _sortParam$split2[0],
      desc = _sortParam$split2[1];
    return [{
      id: id,
      desc: desc === 'desc'
    }];
  }
  return [];
}